import { render } from "./CreateNewUserLayout.vue?vue&type=template&id=5ade542c&ts=true"
import script from "./CreateNewUserLayout.vue?vue&type=script&lang=ts"
export * from "./CreateNewUserLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__